import api from "../../service/api";
import { EResponseEmail } from "./enums";
import { IReturn, ISendEmail } from "./interfaces";

export const sendEmail = async (dataPost: ISendEmail) => {
    let dataReturn: IReturn = {
        message: ""
    };
    const {endpoint, ...rest} = dataPost;
    
    try {
        await api.post(endpoint, {
            ...rest
        });

        return dataReturn = {
            message: EResponseEmail.SUCCESS
        }
    } catch (error) {
        return dataReturn = {
            message: EResponseEmail.FAILED
        }
    }
}